import React  from 'react'
import SignUpForm from './SignUpForm'
import { Container } from 'reactstrap'

const SignUpPage = () => (
  <div>
    <Container>
      <h1>SignUp</h1>
      <SignUpForm/>
    </Container>
  </div>
)

export default SignUpPage